export const itemsDestroyedColumns = [
    {
      Header: 'Items Id',
      accessor: 'itemsId',
    },
    {
      Header: 'Items Name',
      accessor: 'itemsName',
    },
    {
      Header: 'Category Name',
      accessor: 'categoryName',
    },
    {
        Header: 'Destroyed Quantity',
        accessor: 'destroyedQuantity',
    },
    {
        Header: 'Comment',
        accessor: 'comment',
    },
    {
      Header: 'Actions',
      accessor: 'actions',
    }
  ];

export const itemsDestroyedTableData = [
    {   
        itemsId:'1101',
        itemsName:'Bed Cover',
        categoryName:'House Keeping',
        destroyedQuantity: '04',
        comment: 'Dark Spot Not Remove'
    },
    {   
        itemsId:'1102',
        itemsName:'Chairs',
        categoryName:'House Keeping',
        destroyedQuantity: '03',
        comment: 'Breck Chairs'
    },
    {   
        itemsId:'1103',
        itemsName:'Locker Godrej',
        categoryName:'Facility',
        destroyedQuantity: '02',
        comment: 'Electric Power Problems'
    },
    {   
      itemsId:'1104',
      itemsName:'Tea Table',
      categoryName:'Facility',
      destroyedQuantity: '04',
      comment: 'Electric Power Problems'
    },
    {   
      itemsId:'1105',
      itemsName:'Tv',
      categoryName:'Facility',
      destroyedQuantity: '03',
      comment: 'Electric Power Problems'
    },
    {   
      itemsId:'1106',
      itemsName:'Shower',
      categoryName:'Facility',
      destroyedQuantity: '04',
      comment: 'Electric Power Problems'
    },
    {   
      itemsId:'1107',
      itemsName:'Dresing Table',
      categoryName:'Facility',
      destroyedQuantity: '05',
      comment: 'Electric Power Problems'
    },
]